(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.category-tiles[data-section-id]');
  
  sections.forEach(section => {
    const container = section.querySelector('.category-tiles__container');
    const track = section.querySelector('[data-slider-track]');
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');
    
    if (!container || !track) return;
    
    const totalCards = parseInt(container.dataset.totalCards) || 0;
    const isSliderMobile = container.dataset.sliderMobile === 'true';
    const isSliderDesktop = container.dataset.sliderDesktop === 'true';
    
    let currentIndex = 0;
    let isTransitioning = false;
    
    // Responsive cards per page
    const getCardsPerPage = () => {
      const width = window.innerWidth;
      if (width < 768) return 1;
      if (width < 1024) return 2;
      if (width < 1400) return 3;
      return 4;
    };
    
    // Check if slider mode is active
    const isSliderActive = () => {
      const width = window.innerWidth;
      if (width < 768) return isSliderMobile;
      return isSliderDesktop;
    };
    
    let cardsPerPage = getCardsPerPage();
    let maxSlides = Math.max(0, totalCards - cardsPerPage);
    
    // Update arrow visibility
    const updateArrows = () => {
      if (!prevBtn || !nextBtn) return;
      
      maxSlides = Math.max(0, totalCards - cardsPerPage);
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxSlides;
      
      // Hide/show arrows based on slider mode
      const sliderActive = isSliderActive();
      prevBtn.style.display = sliderActive && totalCards > cardsPerPage ? 'flex' : 'none';
      nextBtn.style.display = sliderActive && totalCards > cardsPerPage ? 'flex' : 'none';
    };
    
    // Go to specific slide
    const goToSlide = (index) => {
      if (isTransitioning || !isSliderActive()) return;
      isTransitioning = true;
      
      currentIndex = Math.max(0, Math.min(index, maxSlides));
      
      const slides = track.querySelectorAll('.category-tile');
      if (slides.length > 0) {
        const slideWidth = slides[0].getBoundingClientRect().width;
        const gap = parseInt(getComputedStyle(track).gap) || 20;
        track.style.transform = `translateX(-${currentIndex * (slideWidth + gap)}px)`;
      }
      
      updateArrows();
      setTimeout(() => { isTransitioning = false; }, 500);
    };
    
    // Reset slider position
    const resetSlider = () => {
      if (!isSliderActive()) {
        track.style.transform = 'translateX(0)';
        currentIndex = 0;
      }
      updateArrows();
    };
    
    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) goToSlide(currentIndex - 1);
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (currentIndex < maxSlides) goToSlide(currentIndex + 1);
      });
    }
    
    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    const minSwipeDistance = 50;
    
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const swipeDistance = touchStartX - touchEndX;
      
      if (Math.abs(swipeDistance) > minSwipeDistance && isSliderActive()) {
        if (swipeDistance > 0 && currentIndex < maxSlides) {
          goToSlide(currentIndex + 1);
        } else if (swipeDistance < 0 && currentIndex > 0) {
          goToSlide(currentIndex - 1);
        }
      }
    }, { passive: true });
    
    // Resize handler
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newCardsPerPage = getCardsPerPage();
        if (newCardsPerPage !== cardsPerPage) {
          cardsPerPage = newCardsPerPage;
          maxSlides = Math.max(0, totalCards - cardsPerPage);
          if (currentIndex > maxSlides) currentIndex = maxSlides;
          goToSlide(currentIndex);
        }
        resetSlider();
      }, 250);
    });
    
    // Initialize
    updateArrows();
    resetSlider();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const backToTopBtn = document.getElementById('backToTop');

  if (backToTopBtn) {
    window.addEventListener('scroll', () => {
      backToTopBtn.classList.toggle('visible', window.scrollY > 300);
    }, { passive: true });

    backToTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // ================================
    // Full-Page Mega Search Functionality
    // ================================
    const searchMega = document.querySelector('[data-search-mega]');
    const searchMegaOverlay = document.querySelector('[data-search-mega-overlay]');
    const searchMegaClose = document.querySelectorAll('[data-search-mega-close]');
    const searchMegaClear = document.querySelector('[data-search-mega-clear]');
    const searchMegaInput = document.querySelector('[data-search-mega-input]');
    const searchMegaDefault = document.querySelector('[data-search-mega-default]');
    const searchMegaResults = document.querySelector('[data-search-mega-results]');
    const searchNoResults = document.querySelector('[data-search-no-results]');
    const searchViewAll = document.querySelector('[data-search-view-all]');
    
    // Header search bar trigger
    const headerSearchInput = document.querySelector('[data-predictive-search-input]');
    const headerSearchForm = document.querySelector('[data-predictive-search-form]');
    
    // Popular search tags
    const searchTags = document.querySelectorAll('[data-search-term]');
    
    let searchTimeout = null;
    let currentQuery = '';
    const DEBOUNCE_DELAY = 300;
    const MIN_QUERY_LENGTH = 2;
    
    // Open mega search when clicking header search (desktop)
    if (headerSearchInput) {
      headerSearchInput.addEventListener('focus', openMegaSearch);
      headerSearchInput.addEventListener('click', openMegaSearch);
    }
    
    if (headerSearchForm) {
      headerSearchForm.addEventListener('submit', function(e) {
        e.preventDefault();
        openMegaSearch();
      });
    }
    
    // Open mega search from mobile header search bar
    const mobileSearchTrigger = document.querySelector('[data-mobile-search-trigger]');
    if (mobileSearchTrigger) {
      mobileSearchTrigger.addEventListener('click', openMegaSearch);
    }

    // Open mega search from compact scrolled header search
    const compactSearchTrigger = document.querySelector('[data-compact-search-trigger]');
    if (compactSearchTrigger) {
      compactSearchTrigger.addEventListener('click', openMegaSearch);
    }
    
    // Close mega search (back button)
    searchMegaClose.forEach(btn => {
      btn.addEventListener('click', closeMegaSearch);
    });
    
    if (searchMegaOverlay) {
      searchMegaOverlay.addEventListener('click', closeMegaSearch);
    }
    
    // Clear search input (X button)
    if (searchMegaClear) {
      searchMegaClear.addEventListener('click', clearSearch);
    }
    
    // Escape key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchMega && searchMega.classList.contains('is-open')) {
        closeMegaSearch();
      }
    });
    
    // Popular search tags click
    searchTags.forEach(tag => {
      tag.addEventListener('click', function(e) {
        e.preventDefault();
        const term = this.dataset.searchTerm;
        if (searchMegaInput) {
          searchMegaInput.value = term;
          updateClearButtonVisibility();
          performSearch(term);
        }
      });
    });
    
    // Handle mega search input
    if (searchMegaInput) {
      searchMegaInput.addEventListener('input', function() {
        const query = this.value.trim();
        
        updateClearButtonVisibility();
        clearTimeout(searchTimeout);
        
        if (query.length < MIN_QUERY_LENGTH) {
          showDefaultContent();
          return;
        }
        
        searchTimeout = setTimeout(() => {
          if (query !== currentQuery) {
            currentQuery = query;
            performSearch(query);
          }
        }, DEBOUNCE_DELAY);
      });
    }
    
    function openMegaSearch() {
      if (searchMega) {
        searchMega.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        
        // Focus the mega search input after animation
        setTimeout(() => {
          if (searchMegaInput) {
            searchMegaInput.focus();
            // Copy value from header search if any
            if (headerSearchInput && headerSearchInput.value) {
              searchMegaInput.value = headerSearchInput.value;
              updateClearButtonVisibility();
              if (headerSearchInput.value.length >= MIN_QUERY_LENGTH) {
                performSearch(headerSearchInput.value);
              }
            }
          }
        }, 400);
      }
    }
    
    function closeMegaSearch() {
      if (searchMega) {
        searchMega.classList.remove('is-open');
        document.body.style.overflow = '';
        currentQuery = '';
        
        // Clear inputs
        if (searchMegaInput) searchMegaInput.value = '';
        if (headerSearchInput) headerSearchInput.value = '';
        
        // Hide clear button
        updateClearButtonVisibility();
        
        // Reset to default view
        showDefaultContent();
      }
    }
    
    function clearSearch() {
      if (searchMegaInput) {
        searchMegaInput.value = '';
        searchMegaInput.focus();
      }
      if (headerSearchInput) {
        headerSearchInput.value = '';
      }
      currentQuery = '';
      updateClearButtonVisibility();
      showDefaultContent();
    }
    
    function updateClearButtonVisibility() {
      if (searchMegaClear && searchMegaInput) {
        if (searchMegaInput.value.length > 0) {
          searchMegaClear.classList.add('is-visible');
        } else {
          searchMegaClear.classList.remove('is-visible');
        }
      }
    }
    
    function showDefaultContent() {
      if (searchMegaDefault) searchMegaDefault.style.display = '';
      if (searchMegaResults) searchMegaResults.style.display = 'none';
      if (searchNoResults) searchNoResults.style.display = 'none';
      if (searchViewAll) searchViewAll.style.display = 'none';
    }
    
    function showResultsContent() {
      if (searchMegaDefault) searchMegaDefault.style.display = 'none';
      if (searchMegaResults) searchMegaResults.style.display = '';
    }
    
    async function performSearch(query) {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku`
        );
        
        if (!response.ok) throw new Error('Search failed');
        
        const data = await response.json();
        renderResults(data.resources.results, query);
        showResultsContent();
      } catch (error) {
        console.error('Search error:', error);
      }
    }
    
    async function renderResults(results, query) {
      await window.productVisibilityReady;
      results.products = (await window.ProductVisibility.verify(results.products)).map(product => ({
        ...product,
        price: product.variants[0].price / 100,
        compare_at_price_max: (product.variants[0].compare_at_price || 0) / 100
      }));
      const productsSection = document.querySelector('[data-results-section="products"]');
      const collectionsSection = document.querySelector('[data-results-section="collections"]');
      const pagesSection = document.querySelector('[data-results-section="pages"]');
      const productsContainer = document.querySelector('[data-results-products]');
      const collectionsContainer = document.querySelector('[data-results-collections]');
      const pagesContainer = document.querySelector('[data-results-pages]');
      
      let hasResults = false;
      
      // Render products
      if (results.products && results.products.length > 0) {
        hasResults = true;
        productsSection.classList.add('has-results');
        productsContainer.innerHTML = results.products.map(product => {
          const image = product.image ? 
            `<img src="${getSizedImageUrl(product.image, '300x')}" alt="${escapeHtml(product.title)}" loading="lazy">` :
            `<div class="search-mega__result-image--placeholder"><span class="material-symbols-outlined">image</span></div>`;
          
          const price = formatMoney(product.price);
          const isOnSale = product.compare_at_price_max > product.price;
          const comparePrice = isOnSale ? 
            `<s>${formatMoney(product.compare_at_price_max)}</s>` : '';
          const priceClass = isOnSale ? 'search-mega__result-price--sale' : '';
          const discountPct = isOnSale ? Math.round((product.compare_at_price_max - product.price) / product.compare_at_price_max * 100) : 0;
          const badge = isOnSale ? `<span class="search-mega__result-badge">-${discountPct}%</span>` : '';
          
          return `
            <a href="${product.url}" class="search-mega__result-product">
              <div class="search-mega__result-image">${image}${badge}</div>
              <span class="search-mega__result-title">${highlightMatch(product.title, query)}</span>
              <span class="search-mega__result-price ${priceClass}">${comparePrice}${price}</span>
            </a>
          `;
        }).join('');
      } else {
        productsSection.classList.remove('has-results');
        productsContainer.innerHTML = '';
      }
      
      // Render collections
      if (results.collections && results.collections.length > 0) {
        hasResults = true;
        collectionsSection.classList.add('has-results');
        collectionsContainer.innerHTML = results.collections.map(collection => `
          <a href="${collection.url}" class="search-mega__results-item">
            <span class="search-mega__results-item-icon">
              <span class="material-symbols-outlined">category</span>
            </span>
            <span class="search-mega__results-item-text">${highlightMatch(collection.title, query)}</span>
          </a>
        `).join('');
      } else {
        collectionsSection.classList.remove('has-results');
        collectionsContainer.innerHTML = '';
      }
      
      // Render pages
      if (results.pages && results.pages.length > 0) {
        hasResults = true;
        pagesSection.classList.add('has-results');
        pagesContainer.innerHTML = results.pages.map(page => `
          <a href="${page.url}" class="search-mega__results-item">
            <span class="search-mega__results-item-icon">
              <span class="material-symbols-outlined">article</span>
            </span>
            <span class="search-mega__results-item-text">${highlightMatch(page.title, query)}</span>
          </a>
        `).join('');
      } else {
        pagesSection.classList.remove('has-results');
        pagesContainer.innerHTML = '';
      }
      
      // Show/hide no results
      if (searchNoResults) {
        searchNoResults.style.display = hasResults ? 'none' : '';
      }
      
      // Show/hide view all
      if (searchViewAll) {
        searchViewAll.style.display = hasResults ? '' : 'none';
        searchViewAll.href = `/search?q=${encodeURIComponent(query)}`;
      }
    }
    
    function highlightMatch(text, query) {
      if (!query) return escapeHtml(text);
      const escapedText = escapeHtml(text);
      const regex = new RegExp(`(${escapeRegex(query)})`, 'gi');
      return escapedText.replace(regex, '<mark>$1</mark>');
    }
    
    function escapeRegex(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    
    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    function formatMoney(priceValue) {
      // Shopify predictive search API returns prices already formatted
      // Just ensure 2 decimal places
      const amount = parseFloat(priceValue).toFixed(2);
      return amount + ' JOD';
    }
    
    function getSizedImageUrl(url, size) {
      if (!url) return '';
      if (url.includes('_' + size)) return url;
      const match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
      if (match) {
        return url.replace(match[0], '_' + size + match[0]);
      }
      return url;
    }
  });

  // ================================
  // Desktop mega menu
  // ================================
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const items = header.querySelectorAll('[data-mega-item]');
    const canHover = window.matchMedia('(hover: hover)');
    let openTimer = null;
    let closeTimer = null;

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', String(open));
      header.classList.toggle('is-mega-open', !!header.querySelector('[data-mega-item].is-open'));
    }

    function closeAll(except) {
      items.forEach((item) => {
        if (item !== except) setOpen(item, false);
      });
    }

    items.forEach((item) => {
      const trigger = item.querySelector('[data-mega-trigger]');

      item.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(() => {
          closeAll(item);
          setOpen(item, true);
        }, header.classList.contains('is-mega-open') ? 0 : 90);
      });

      item.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => setOpen(item, false), 160);
      });

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });

      // Touch screens: first tap opens the panel, second tap follows the link
      trigger?.addEventListener('click', (event) => {
        if (canHover.matches || item.classList.contains('is-open')) return;
        event.preventDefault();
        closeAll(item);
        setOpen(item, true);
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-mega-item]')) closeAll();
    });

    // Coming back with the browser's Back button restores the page as it was left
    window.addEventListener('pageshow', () => closeAll());

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openItem = header.querySelector('[data-mega-item].is-open');
      if (!openItem) return;
      setOpen(openItem, false);
      openItem.querySelector('[data-mega-trigger]')?.focus();
    });
  })();

  // ================================
  // Mobile menu
  // ================================
  (function () {
    const header = document.querySelector('[data-site-header]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!header || !menu) return;

    const toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
    const panels = menu.querySelectorAll('[data-mobile-panel]:not([data-mobile-panel="root"])');
    const rootPanel = menu.querySelector('[data-mobile-panel="root"]');
    const desktop = window.matchMedia('(min-width: 1024px)');

    function isOpen() {
      return menu.classList.contains('is-open');
    }

    function showPanel(panel) {
      panels.forEach((item) => {
        const active = item === panel;
        item.classList.toggle('is-active', active);
        item.classList.toggle('is-behind', !!panel && panel.dataset.parentPanel === item.id);
        item.inert = !active;
      });
      menu.querySelectorAll('[data-panel-open]').forEach((button) => {
        button.setAttribute('aria-expanded', String(!!panel && button.dataset.panelOpen === panel.id));
      });
      menu.classList.toggle('has-panel-open', !!panel);
      rootPanel.inert = !!panel;
      const focusTarget = panel ? panel.querySelector('button, a') : null;
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      if (panel) panel.scrollTop = 0;
    }

    function setMenu(open) {
      menu.classList.toggle('is-open', open);
      header.classList.toggle('is-menu-open', open);
      document.documentElement.classList.toggle('is-scroll-locked', open);
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
      if (!open) showPanel(null);
      if (open) rootPanel.querySelector('button, a')?.focus({ preventScroll: true });
    }

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => setMenu(!isOpen()));
    });

    menu.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-panel-open]');
      if (opener) {
        showPanel(document.getElementById(opener.dataset.panelOpen));
        return;
      }

      if (event.target.closest('[data-panel-back]')) {
        const panel = event.target.closest('[data-mobile-panel]');
        const parent = panel?.dataset.parentPanel ? document.getElementById(panel.dataset.parentPanel) : null;
        showPanel(parent);
        menu.querySelector(`[data-panel-open="${panel?.id}"]`)?.focus({ preventScroll: true });
        return;
      }

      const accordion = event.target.closest('[data-accordion-toggle]');
      if (accordion) {
        const expanded = accordion.getAttribute('aria-expanded') === 'true';
        accordion.setAttribute('aria-expanded', String(!expanded));
        document.getElementById(accordion.getAttribute('aria-controls')).hidden = expanded;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        setMenu(false);
        header.querySelector('.site-header__menu-toggle')?.focus();
      }
    });

    desktop.addEventListener('change', (event) => {
      if (event.matches && isOpen()) setMenu(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductTabs(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-panel]'));

      function select(index, focus) {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
        });
        if (focus) tabs[index].focus();
        updateArrows(panels[index]);
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          select((index + step + tabs.length) % tabs.length, true);
        });
      });

      function updateArrows(panel) {
        const track = panel.querySelector('[data-track]');
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        panel.querySelector('[data-scroll="-1"]').disabled = track.scrollLeft <= 2;
        panel.querySelector('[data-scroll="1"]').disabled = track.scrollLeft >= maxScroll;
      }

      panels.forEach((panel) => {
        const track = panel.querySelector('[data-track]');
        panel.querySelectorAll('[data-scroll]').forEach((button) => {
          button.addEventListener('click', () => {
            track.scrollBy({ left: Number(button.dataset.scroll) * track.clientWidth * 0.8, behavior: 'smooth' });
          });
        });
        track.addEventListener('scroll', () => updateArrows(panel), { passive: true });
        updateArrows(panel);
      });
    }

    document.querySelectorAll('[data-product-tabs]').forEach(initProductTabs);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-product-tabs]').forEach(initProductTabs);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-countdown]').forEach(countdown => {
    const targetDate = new Date(countdown.dataset.countdown).getTime();
    
    const updateCountdown = () => {
      const now = new Date().getTime();
      const diff = targetDate - now;
      
      if (diff < 0) {
        countdown.style.display = 'none';
        return;
      }
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      const daysEl = countdown.querySelector('[data-days]');
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');
      
      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    };
    
    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-mosaic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRotator(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const slides = Array.from(root.querySelectorAll('[data-promo-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-promo-dot]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index = 0;
      let timer = null;

      function show(next) {
        index = next;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (reducedMotion || window.Shopify?.designMode) return;
        timer = setInterval(() => {
          if (!document.hidden) show((index + 1) % slides.length);
        }, Number(root.dataset.speed) || 5000);
      }

      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      /* Mouse: pause while hovering. Touch: pause only while a finger is on the section. */
      root.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') stop();
      });
      root.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') start();
      });
      root.addEventListener('touchstart', stop, { passive: true });
      ['touchend', 'touchcancel'].forEach((type) => {
        root.addEventListener(type, (event) => {
          if (event.touches.length === 0) start();
        }, { passive: true });
      });

      /* Keyboard focus also pauses; a tap's focus must not, or switching would stay stopped */
      let keyboardPaused = false;
      root.addEventListener('focusin', (event) => {
        if (!event.target.matches(':focus-visible')) return;
        keyboardPaused = true;
        stop();
      });
      root.addEventListener('focusout', () => {
        if (!keyboardPaused) return;
        keyboardPaused = false;
        start();
      });

      root.promoRotator = { show, slides };
      start();
    }

    document.querySelectorAll('[data-promo-rotator]').forEach(initRotator);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-promo-rotator]').forEach(initRotator);
    });

    /* Theme editor: selecting a tile brings its set into view */
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-promo-slide]');
      const rotator = slide?.closest('[data-promo-rotator]')?.promoRotator;
      if (rotator) rotator.show(rotator.slides.indexOf(slide));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonials-slider]').forEach(slider => {
    const track = slider.querySelector('[data-testimonials-track]');
    const prevBtn = slider.querySelector('[data-testimonials-prev]');
    const nextBtn = slider.querySelector('[data-testimonials-next]');
    const dotsContainer = slider.querySelector('[data-testimonials-dots]');
    const cards = track.querySelectorAll('.testimonial-card');
    
    let currentIndex = 0;
    let slidesPerView = 1;
    
    const updateSlidesPerView = () => {
      if (window.innerWidth >= 1024) slidesPerView = 3;
      else if (window.innerWidth >= 768) slidesPerView = 2;
      else slidesPerView = 1;
    };
    
    const totalSlides = () => Math.ceil(cards.length / slidesPerView);
    
    const updateSlider = () => {
      const slideWidth = 100 / slidesPerView;
      track.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
      updateDots();
    };
    
    const createDots = () => {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      for (let i = 0; i < totalSlides(); i++) {
        const dot = document.createElement('button');
        dot.className = 'testimonials__dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', () => {
          currentIndex = i;
          updateSlider();
        });
        dotsContainer.appendChild(dot);
      }
    };
    
    const updateDots = () => {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('.testimonials__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    };
    
    const goNext = () => {
      currentIndex = (currentIndex + 1) % totalSlides();
      updateSlider();
    };
    
    const goPrev = () => {
      currentIndex = (currentIndex - 1 + totalSlides()) % totalSlides();
      updateSlider();
    };
    
    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    
    updateSlidesPerView();
    createDots();
    
    window.addEventListener('resize', () => {
      updateSlidesPerView();
      currentIndex = 0;
      createDots();
      updateSlider();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      const page = document.querySelector('[data-wishlist-page]');
      if (!page) return;

      const grid = page.querySelector('[data-wishlist-grid]');
      const empty = page.querySelector('[data-wishlist-empty]');
      const cache = new Map();
      let renderId = 0;

      async function fetchCard(handle) {
        if (cache.has(handle)) return cache.get(handle);
        const request = fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}?section_id=wishlist-item`)
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelector('.product-card');
          })
          .catch(() => null);
        cache.set(handle, request);
        return request;
      }

      async function render() {
        const id = ++renderId;
        const cards = await Promise.all(window.Wishlist.read().map(fetchCard));
        if (id !== renderId) return;
        grid.replaceChildren(...cards.filter(Boolean).map((card) => card.cloneNode(true)));
        page.classList.remove('is-loading');
        empty.hidden = grid.children.length > 0;
        window.Wishlist.sync(grid);
      }

      document.addEventListener('wishlist:change', render);
      render();
    }

    /* The compiled section scripts can run before the deferred wishlist.js */
    if (window.Wishlist) {
      init();
    } else {
      document.addEventListener('wishlist:ready', init, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
